// extracted by mini-css-extract-plugin
export default {"loader":"Te0JvwwlKwTtS2sADUFgKA==","loading":"dXyf9d-sAKBWk56CV02+kw=="};